import { ContentLayout } from '@/bundle/Layouts/ContentLayout/ContentLayout';
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query';
import { OpcoUsersTable } from './ui/OpcoUsersTable';
import { PageFooter } from '@/components/Page/PageFooter/PageFooter';
import { Paginator } from '@/components/Paginator/Paginator';
import { PageBody } from '@/components/Page/PageBody/PageBody';
import { useState } from 'react';
import { Drawer } from '@/components/Drawer/Drawer';
import { CreateOpcoUserForm } from './ui/CreateOpcoUserForm/CreateOpcoUserForm';
import { Button } from '@/components/Button/Button';
import PlusIcon from '../../../images/PlusIcon.svg?react';
import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { loadOpcoUsers } from '@/bundle/_Opco/_OpcoUsersPage/api/api';
import { getListData } from '@/helpers/helpers';

export const OpcoUsersPage = () => {
  const queryClient = useQueryClient();
  const searchParams = useGetSearchParams();
  const [isOpen, setIsOpen] = useState(false);

  const { data, isPending } = useQuery({
    queryKey: ['load_opco_users', searchParams],
    queryFn: () => loadOpcoUsers(searchParams),
    placeholderData: keepPreviousData,
  });

  const openCreateUserForm = () => {
    setIsOpen(true);
  };

  const closeForm = () => {
    setIsOpen(false);
  };

  const createOpcoUserSuccess = () => {
    closeForm();
    queryClient.invalidateQueries({ queryKey: ['load_opco_users'] });
  };

  const { list, totalCount, hasPagination } = getListData(data?.body, searchParams);

  return (
    <ContentLayout
      title='OpCo Users'
      breadcrumbs='OpCo Users'
      subtitle={
        <>
          View the list of OpCo Users.
          <br />
          Click on a particular row to view the data for the particular User.
        </>
      }
      headerAction={
        <Button width={150} iconPosition='left' icon={<PlusIcon />} onClick={openCreateUserForm} mobileStretch>
          Create User
        </Button>
      }
    >
      <PageBody>
        <OpcoUsersTable items={list} isLoading={isPending} />
      </PageBody>
      {hasPagination && (
        <PageFooter>
          <Paginator page={searchParams.page} limit={searchParams.limit} total={totalCount} />
        </PageFooter>
      )}

      <Drawer
        isOpen={isOpen}
        onClose={closeForm}
        header='Create OpCo Admin'
        subHeader={<>Please provide information for the new OpCo Admin.</>}
      >
        <CreateOpcoUserForm onCancel={closeForm} onSuccess={createOpcoUserSuccess} />
      </Drawer>
    </ContentLayout>
  );
};
